import React from "react";
import { FontAwesomeIcon as FontAwesomeIconComponent } from "@fortawesome/react-fontawesome";

import styles from "./fontAwesomeIcon.module.scss";

type Props = {
  icon: any,
  className?: string
};
const Index = ({ icon, className }: Props) => {
  return (
    <FontAwesomeIconComponent
      icon={icon}
      className={`${styles.base} ${className}`}
    />
  );
};

export default Index;
